import React from 'react';
import { Trash2, Shield } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '../ui/table';
import { formatCurrency } from '../../lib/utils';

const ANIMAL_LABELS = {
  'pollo': 'Pollo',
  'gallina': 'Gallina', 
  'cerdo': 'Cerdo',
  'becerro': 'Becerro'
};

// Colores para badges de animales
const ANIMAL_COLORS = {
  'pollo': 'bg-red-100 text-red-800',
  'gallina': 'bg-green-100 text-green-800',
  'cerdo': 'bg-pink-100 text-pink-800',
  'becerro': 'bg-amber-100 text-amber-800'
};

export function ProductsTable({ products, formulas, isSuperUser, onDelete, operationalCostPerUnit = 0 }) {
  return (
    <Card className="border-slate-200">
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow className="bg-slate-50">
              <TableHead>Producto</TableHead>
              <TableHead>Animal</TableHead>
              <TableHead>Fórmula</TableHead>
              <TableHead>Unidad</TableHead>
              <TableHead className="text-right">Costo Producción</TableHead>
              <TableHead className="text-center">Acciones</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {products.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} className="text-center py-8 text-slate-500">
                  No hay productos registrados
                </TableCell>
              </TableRow>
            ) : (
              products.map((product) => {
                // Obtener el costo de la fórmula vinculada (solo materiales)
                const formula = formulas?.find(f => f.id === product.formula_id);
                const formulaCostUSD = formula?.unit_cost_usd || 0;
                const formulaCostDOP = formula?.unit_cost || 0;
                // Costo total = fórmula + operativo
                const totalCostUSD = formula ? formulaCostUSD + operationalCostPerUnit : (product.price_usd || 0);
                const totalCostDOP = formula ? formulaCostDOP + (operationalCostPerUnit * 62) : (product.price_dop || 0);
                // Obtener el animal del producto o de la fórmula
                const animalType = product.animal_type || formula?.animal_type;
                
                return (
                  <TableRow key={product.id}>
                    <TableCell>
                      <p className="font-medium">{product.name}</p>
                    </TableCell>
                    <TableCell>
                      {animalType ? (
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${ANIMAL_COLORS[animalType] || 'bg-blue-100 text-blue-800'}`}>
                          {ANIMAL_LABELS[animalType] || animalType}
                        </span>
                      ) : (
                        <span className="text-xs text-slate-400">-</span>
                      )}
                    </TableCell>
                    <TableCell>
                      {formula ? (
                        <span className="text-sm text-slate-600">{formula.name}</span>
                      ) : (
                        <span className="text-xs text-slate-400">Sin fórmula</span>
                      )}
                    </TableCell>
                    <TableCell>{product.unit}</TableCell>
                    <TableCell className="text-right">
                      <div>
                        <p className="font-semibold">{formatCurrency(totalCostUSD, 'USD')}</p>
                        <p className="text-sm text-green-600">({formatCurrency(totalCostDOP)})</p>
                      </div>
                    </TableCell>
                    <TableCell className="text-center">
                      <Button 
                        variant="ghost" size="sm"
                        onClick={() => onDelete(product)}
                        className={`hover:bg-red-50 ${isSuperUser ? 'text-red-600 hover:text-red-700' : 'text-slate-400 hover:text-slate-500'}`}
                        title={isSuperUser ? 'Eliminar' : 'Requiere Super Usuario'}
                      >
                        <Trash2 className="h-4 w-4" />
                        {!isSuperUser && <Shield className="h-3 w-3 ml-0.5 text-amber-500" />}
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
